import React from 'react';
import ReactDOM from 'react-dom/client';
// Import design system CSS at the very top level for Module Federation
// Single import includes everything: reset, variables, fonts, and typography utilities
import '@sequel-ae/lore-design-system/dist/styles/index.css';
import '@ionic/react/css/core.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

